module.exports = __webpack_public_path__ + "img/locked_circle.61b8fc8d.svg";